import type { ShippingError } from './Shipping.types'

export function intersect<T>(array1: T[], array2: T[]) {
  return array1.filter((value) => array2.includes(value))
}

export function distinctArray<T>(values: T[]) {
  return [...new Set(values)]
}

export function getApiErrorsMessage(error: ShippingError) {
  if (error.errors?.length) {
    return error.errors
  }

  return [
    {
      detail: '',
      target: '',
      title: error.title,
      type: '',
    },
  ]
}
